(() => {
  'use strict';
  if (customElements.get('predictive-search')) return;
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('.predictive-results');
      this.status = this.querySelector('[data-search-status]');
      this.sequence = 0;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.sequence++;
        this.results.hidden = true;
        if (this.input.value.trim().length < 2) { this.status.textContent = ''; return; }
        this.timer = setTimeout(() => this.search(), 180);
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { this.results.hidden = true; this.input.focus(); return; }
        if (this.results.hidden || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        const links = [...this.results.querySelectorAll('a')];
        if (!links.length) return;
        event.preventDefault();
        const index = links.indexOf(document.activeElement);
        const next = event.key === 'ArrowDown' ? (index + 1) % links.length : (index <= 0 ? links.length - 1 : index - 1);
        links[next].focus();
      });
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.results.hidden = true; });
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
    async search() {
      const sequence = this.sequence;
      const term = this.input.value.trim();
      this.controller = new AbortController();
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('resources[type]', 'product,collection,article');
      url.searchParams.set('resources[limit]', '4');
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor');
      url.searchParams.set('section_id', 'predictive-search');
      this.status.textContent = this.dataset.loading;
      try {
        const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Search unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (sequence !== this.sequence) return;
        const content = document.querySelector('[data-predictive-content]');
        if (!content) throw new Error('Missing search results');
        this.results.replaceChildren(...content.childNodes);
        this.results.hidden = !this.contains(window.document.activeElement);
        this.status.textContent = this.results.querySelector('[data-result-count]')?.textContent || '';
      } catch (error) {
        if (error.name !== 'AbortError' && sequence === this.sequence) { this.results.hidden = true; this.status.textContent = ''; }
      }
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
})();
